<template>
    <div class="history_deal">
        <span class="icon_timeline" :style="`background-color: ${$options.filters.pmlAccessWayById(item.access_way_id, 'color')};`" v-if="item.member_id"> {{ item.member_id | pmlMemberById('name_initials') }} </span>
        <span class="icon_timeline" style="background-color: #8338b1" v-else>PML</span>
        <h3 class="title_history" v-if="item.member_id">
            {{ item.member_id | pmlMemberById('full_name') }}
            <span class="label label-sm pull-right m-t-5" :style="`background-color: ${$options.filters.pmlAccessWayById(item.access_way_id, 'color')};`"> {{ item.access_way_id | pmlAccessWayById('name') }} </span>
        </h3>
        <h3 class="title_history" v-else>
            Pump My Lead
            <span class="label label-sm pull-right m-t-5" style="background-color: #8338b1"> {{ $t('auto') }} </span>
        </h3>
        <small class="show time_follow m-b-10">
            <span class="bold">{{ item.created_at | pmlDate('DD/MM/YYYY HH:mm') }}</span>
            <small class="text-muted">({{ item.created_at | pmlHumanDate }})</small>
        </small>
        <div class="show m-b-10">
            <a :href="`/deals/${item.deal_id}/follow-ups`" class="time_line_avatar">
                <img :src="item.deal.lead.avatar || '/static/images/avatar.jpg'" title="Nome do lead" class="img-circle pull-left thumb-20 m-r-5">
                {{`#${item.deal.code} - ${item.deal.lead.full_name}`}}
                <small class="text-muted" v-if="item.deal.lead.reference">({{ item.deal.lead.reference }})</small>
            </a>
        </div>
        <div class="txt_history" :class="{ 'collapsed': collapsed }">
            <div v-html="formatContent(item.content)"></div>
            <div class="pointer collapse-button" :class="{ 'collapsed': collapsed }" @click="collapsed = !collapsed"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TimelineItem',
        props: ['item'],
        data () {
            return {
                collapsed: true
            }
        },
        methods: {
            formatContent (content) {
                return this.$options.filters.pmlNl2br(content) || ''
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/reports/follow-ups/components/Item.vue